import React, { useState } from 'react';
import { MessageCircle, Send } from 'lucide-react';
import GradientPillButton from './GradientPillButton';
import GradientIconCircle from './GradientIconCircle';
interface AskGBIntelligenceBarProps {
  onAsk: (question: string, detailed: boolean) => void;
}
const AskGBIntelligenceBar: React.FC<AskGBIntelligenceBarProps> = ({
  onAsk
}) => {
  const [question, setQuestion] = useState('');
  const [detailed, setDetailed] = useState(false);
  const handleSubmit = () => {
    if (question.trim()) {
      onAsk(question, detailed);
      setQuestion('');
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };
  return <div className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm" data-id="element-1192">
      <div className="flex items-center gap-3 mb-3" data-id="element-1193">
        <GradientIconCircle size={36} data-id="element-1194">
          <MessageCircle className="h-5 w-5 text-purple-600" data-id="element-1195" />
        </GradientIconCircle>
        <h3 className="text-sm font-semibold text-gray-900" data-id="element-1196">
          Chiedi a GB Intelligence
        </h3>
      </div>

      <div className="flex items-center gap-3" data-id="element-1197">
        <div className="flex-1 relative" data-id="element-1198">
          <input type="text" value={question} onChange={e => setQuestion(e.target.value)} onKeyPress={handleKeyPress} placeholder="Chiedi a GB Intelligence…" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-1199" />
        </div>

        <div className="flex items-center gap-2" data-id="element-1200">
          <label className="flex items-center gap-2 text-xs text-gray-600" data-id="element-1201">
            <input type="checkbox" checked={detailed} onChange={e => setDetailed(e.target.checked)} className="rounded border-gray-300" data-id="element-1202" />
            Risposta dettagliata
          </label>
        </div>

        <div className="w-32" data-id="element-1203">
          <GradientPillButton onClick={handleSubmit} disabled={!question.trim()} data-id="element-1204">
            <Send className="h-4 w-4 mr-2 text-purple-600" data-id="element-1205" />
            <span className="text-sm font-medium text-gray-900" data-id="element-1206">Chiedi</span>
          </GradientPillButton>
        </div>
      </div>
    </div>;
};
export default AskGBIntelligenceBar;